import React from 'react';
import {
  Box,
  Typography,
  Grid,
  IconButton,
  Stack,
  Divider,
  useTheme,
  useMediaQuery,
  Container,
  Link
} from '@mui/material';
import {
  Facebook,
  Instagram,
  Twitter,
  LinkedIn,
  LocationOn,
  Phone,
  Email,
  WhatsApp
} from '@mui/icons-material';
// import logo from '/Projects/Website/Archive/src/assets/lightlogo.png';

const Footer = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        // backgroundColor: theme.palette.background.paper,
        // color: theme.palette.text.primary,
        backgroundColor:" #3b3b3b",
        color:"white",
        pt: 8,
        pb: 4,
        borderTop: '1px solid #D3D3D3',
        marginTop: 3,
        // borderTopLeftRadius: 100
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and About Section */}
          {/* <Grid  size={{xs:12, sm:6, md:4}}>
            <Box sx={{ mb: 3 }}>
              <img
              src="/image.png"  
                alt="RealEstatePro Logo"
                style={{
                  width: '160px',
                  height: 'auto',
                  filter: theme.palette.mode === 'dark' ? 'brightness(0) invert(1)' : 'none'
                }}
              />
            </Box>
            <Typography variant="body2" color="text.secondary" sx={{ maxWidth: '30ch' }}>
              Transforming real estate with innovative solutions and trusted services.
            </Typography>
          </Grid> */}

          {/* Quick Links */}
          <Grid size={{ xs: 6, sm: 6, md: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              Quick Links
            </Typography>
            <Stack spacing={1.2}>
              {[
                { name: 'Home', path: '/' },
                { name: 'About Us', path: '/about' },
                { name: 'Contact Us', path: '/contact' },
                { name: 'Privacy Policy', path: '/privacy' },
                { name: 'Terms & Conditions', path: "/terms-and-condition" },
                //  { name: 'Refund & Cancellation Policy', path: '/RefundAndCancellationPolicy' },
                 { name: 'Disclaimer', path: '/disclaimer' },
              ].map((item, index) => (
                <Link
                  key={index}
                  href={item.path}
                  underline="none"
                  sx={{
                    // color: theme.palette.text.secondary,
                    color:"white",
                    '&:hover': {
                      color: theme.palette.primary.main,
                      transform: 'translateX(4px)'
                    },
                    transition: 'all 0.2s ease',
                    width: 'fit-content'
                  }}
                >
                  {item.name}
                </Link>
              ))}
            </Stack>
          </Grid>

          {/* Contact Info & Social Icons */}
          <Grid size={{ xs: 12, sm: 12, md: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
              Contact Us
            </Typography>
            <Stack spacing={1.5} sx={{ mb: 3 }}>
              <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                <LocationOn sx={{ mr: 1.5, mt: '2px', fontSize: '1.2rem' }} color="white" />
                <Typography
                  variant="body2"
                  // color="text.secondary"
                  color='white'
                  sx={{
                    whiteSpace: 'pre-line'
                  }}
                >
                  Plot 724,725, 7th Main Road, 707, TNHB Colony Road, Sithalapakkam, Chennai Tamil Nadu 627126
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Phone sx={{ mr: 1.5, fontSize: '1.2rem' }} color="white" />
                <Typography variant="body2" color="white">
                  +91 96296 11466
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Email sx={{ mr: 1.5, fontSize: '1.2rem' }} color="white" />
                <Typography variant="body2" color="white">
                  jemins_realmart@jemins.in
                </Typography>
              </Box>
            </Stack>

            {/* Social Icons */}
            <Stack direction="row" spacing={2}>
              {[
                {
                  icon: <Facebook />,
                  color: '#1877F2',
                  url: 'https://www.facebook.com/jemins.builders'
                },
                {
                  icon: <Instagram />,
                  color: '#E4405F',
                  url: 'https://www.instagram.com/jemins.builders'
                },
                // {
                //   icon: <Twitter />,
                //   color: '#1DA1F2',
                //   url: 'https://www.twitter.com/your-profile'
                // },
                // {
                //   icon: <LinkedIn />,
                //   color: '#0A66C2',
                //   url: 'https://www.linkedin.com/in/your-profile'
                // },
                {
                  icon: <WhatsApp />,
                  color: '#25D366',
                  url: `https://wa.me/919629611466`
                }
              ].map((social, index) => (
                <IconButton
                  key={index}
                  onClick={() => window.open(social.url, '_blank')}
                  sx={{
                    backgroundColor: theme.palette.mode === 'dark'
                      ? theme.palette.grey[800]
                      : theme.palette.grey[100],
                    color: social.color,
                    '&:hover': {
                      backgroundColor: social.color,
                      color: '#fff',
                      transform: 'translateY(-2px)'
                    },
                    transition: 'all 0.3s ease',
                    width: 40,
                    height: 40
                  }}
                >
                  {social.icon}
                </IconButton>
              ))}
            </Stack>
          </Grid>
        </Grid>

        {/* Bottom Footer */}
        <Divider sx={{ my: 4 }} />
        <Box
          sx={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: isMobile ? 'center' : 'left',
            gap: 1,
           
          }}
        >
          <Typography variant="body2" color="white">
            © {new Date().getFullYear()} Jemins Builders And Developers. All rights reserved.
          </Typography>
        
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
